<template>
  <div class="box">
    <!-- 组件名当作标签 -->

    <global-header />
    <div class="main-bg">
      <div class="main-title w-1200 mx-auto fz-24 fw-b">
        <div class="block"></div>
        用户中心
      </div>
      <div class="main w">
        <div class="left">
          <Left :active="0" />
        </div>

        <div class="right">
          <el-card class="box_card1">
            <div class="card-header fw-b">
              <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/title01.svg" alt="">
              <span>个人信息</span>
              <div class="flex-spacer" style="border-bottom: 1px dashed #CCD1DC;margin: 0 15px;"></div>
              <svg-icon icon-class="arrow-down-circle" style="color: #CCD1DC;" />
            </div>
            <div class="card1_main">
              <div class="card1-left">
                <img class="avatar" :src="profile.avatar" alt="">
                <div class="user-info-box">
                  <div class="toal1_list user-name fz-20 fw-b">
                    <span>会员名：</span>
                    <span class="val_total1 profile-name" :title="profile.name">{{ profile.name }}</span>
                    <div class="level fz-12 c-white fw-n">
                      会员等级
                      <span style="color: #85A7D0;">{{ profile.price_level.name }}</span>
                    </div>
                  </div>
                  <div class="toal1_list fz-14">
                    <span>手机号码：</span>
                    <span class="val_total1">{{ profile.mobile }}</span>
                  </div>
                  <div class="balance-box mt-10 fz-14 fw-b">
                    <svg-icon icon-class="currency"
                              style="width: 22px;height: 22px;color: #0070ef;margin-right: 9px;" />
                    账户余额： <span style="color: #ff2222;">{{ profile.balance }}</span>&nbsp;元
                    <div class="btn-recharge fw-n" v-if="profile.recharge===1"
                         @click="$router.push('/recharge_center')">立即充值
                    </div>
                  </div>
                </div>
              </div>
              <div class="card1-right">
                <img :src="customerService.wechat_qrcode" class="erweima" width="100%" height="100%" />

                <div class="personal_new">
                  <div class="personal_list personal-list-title">
                    <span style="width: auto;">专属客户经理</span>
                    <span class="gw fz-12">
                      <svg-icon icon-class="awards" />
                      金牌顾问
                    </span>
                  </div>
                  <div class="personal_list" style="white-space: nowrap;">
                    <span>联系人：{{ customerService.name }}</span>
                    <span>联系电话：{{ customerService.mobile }}</span>
                  </div>
                  <div class="personal_list" style="white-space: nowrap;">
                    <span>微信：{{ customerService.wechat || '无' }}</span>
                    <span>免费热线：4008-520-553</span>
                  </div>
                </div>

              </div>
            </div>
            <div class="card-header fw-b">
              <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/title02.svg" alt="">
              <span>常用功能</span>
              <div class="flex-spacer" style="border-bottom: 1px dashed #CCD1DC;margin: 0 15px;"></div>
              <svg-icon icon-class="arrow-down-circle" style="color: #CCD1DC;" />
            </div>
            <div class="card2_main_con">
              <div class="card2_main">
                <a href="/own/publish" class="card2_main_item">
                  <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/gn01.svg" alt="">
                  <div class="card2_main_item_name">发布文章</div>
                </a>
                <a href="/own/copy_write" class="card2_main_item">
                  <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/gn02.svg" alt="">
                  <div class="card2_main_item_name">代写文章</div>
                </a>
                <a href="/own/news_order" class="card2_main_item">
                  <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/gn03.svg" alt="">
                  <div class="card2_main_item_name">文章列表</div>
                </a>
                <a href="/own/copy_write_list" class="card2_main_item">
                  <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/gn04.svg" alt="">
                  <div class="card2_main_item_name">代写列表</div>
                </a>
                <a href="/recharge_center" class="card2_main_item" v-if="profile.recharge===1">
                  <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/gn05.svg" alt="">
                  <div class="card2_main_item_name">在线充值</div>
                </a>
                <a href="/own/finance/transaction" class="card2_main_item">
                  <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/gn06.svg" alt="">
                  <div class="card2_main_item_name">交易流水
                  </div>
                </a>
                <a href="/own/finance/invoice_list" class="card2_main_item">
                  <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/gn07.svg" alt=""
                       style="margin-top: 5px;">
                  <div class="card2_main_item_name">发票列表
                  </div>
                </a>
                <a href="/own/finance/invoice_info_list" class="card2_main_item">
                  <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/gn08.svg" alt="">
                  <div class="card2_main_item_name">发票审核
                  </div>
                </a>
                <a href="/own/personal/profile" class="card2_main_item">
                  <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/gn09.svg" alt=""
                       style="margin-top: 6px;">
                  <div class="card2_main_item_name">资料编辑</div>
                </a>
                <a href="/own/personal/password" class="card2_main_item">
                  <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/gn10.svg" alt="">
                  <div class="card2_main_item_name">修改密码
                  </div>
                </a>
              </div>
              <div class="carousel-box">
                <el-carousel height="190px" arrow="never">
                  <el-carousel-item v-for="item in 2" :key="item">
                    <img :src="`https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/carousel0${item}.jpg`"
                         alt=""
                         class="carousel-img">
                  </el-carousel-item>
                </el-carousel>
              </div>

            </div>
            <div class="card-header fw-b">
              <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/title03.svg" alt="">
              <span>温馨提示</span>
              <div class="flex-spacer" style="border-bottom: 1px dashed #CCD1DC;margin: 0 15px;"></div>
              <svg-icon icon-class="arrow-down-circle" style="color: #CCD1DC;" />
            </div>
            <div class="card4_main">
              <div class="card4_main_top">
                <div class="time_new">
                  <span>星期一至星期五 ，上午</span><span
                    class="c-0070EF">9:00~12:00</span><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;下午</span><span
                    class="c-0070EF">13:30~18:00</span>
                  <span>星期六、星期天 可在后台自助提交稿件，周一安排发布。</span>
                </div>
              </div>
              <div class="card4_main_bot">
                <el-popover
                    placement="bottom"
                    width="400"
                    trigger="hover"
                    content="填写账号、密码、联系方式，点击[提交]完成注册">
                  <div class="step-item" slot="reference">
                    <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/step01.svg" alt="">
                    <div class="fw-b mt-15">01-注册账号</div>
                  </div>
                </el-popover>
                <el-popover
                    placement="bottom"
                    width="400"
                    trigger="hover"
                    content="登陆后台，点击[在线充值]，选择您的支付方式充值，充值发布文章费用">
                  <div class="step-item" slot="reference">
                    <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/step02.svg" alt="">
                    <div class="fw-b mt-15">02-预存款项</div>
                  </div>
                </el-popover>
                <el-popover
                    placement="bottom"
                    width="400"
                    trigger="hover"
                    content="点击[文章发布]，填写标题、内容，点击[下一步]，选择您要发布的媒体，点击[提交]完成发布">
                  <div class="step-item" slot="reference">
                    <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/step03.svg" alt="">
                    <div class="fw-b mt-15">03-开始发稿</div>
                  </div>
                </el-popover>
                <el-popover
                    placement="bottom"
                    width="400"
                    trigger="hover"
                    content="点击[文章管理]，查看文章发布状态，文章发布成功后后台会显示链接，发布时间24小时内">
                  <div class="step-item" slot="reference">
                    <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/step04.svg" alt="">
                    <div class="fw-b mt-15">04-查看文章</div>
                  </div>
                </el-popover>
                <el-popover
                    placement="bottom"
                    width="400"
                    trigger="hover"
                    content="如果您的文章发布没有发布成功不收费，如您有任何疑问有，可以通过后台显示的QQ联系我们">
                  <div class="step-item" slot="reference">
                    <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/step05.svg" alt="">
                    <div class="fw-b mt-15">05-售后服务</div>
                  </div>
                </el-popover>
                <el-popover
                    placement="bottom"
                    width="400"
                    trigger="hover"
                    content="如果您没有准备文章，点击[文章代写]，填写代写要求，工作时间2日内交稿，不满意可重写">
                  <div class="step-item" slot="reference">
                    <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/step06.svg" alt="">
                    <div class="fw-b mt-15">06-软文代写</div>
                  </div>
                </el-popover>
              </div>
            </div>
            <div class="box5 mx-auto mt-45" style="margin-bottom: 30px;">
              <div class="box5-item"
                   style="background-image: url('https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/bg1.png');">
                <div class="title fz-18 c-white">
                  方案咨询
                  <div class="icon">
                    <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/box5-1.svg" alt="">
                  </div>
                </div>
                <a class="cs-link c-white" href="https://tb.53kf.com/code/client/4fc71c35adbd778bae3a4e749e0b4c898/3"
                   target="_blank">在线咨询</a>
              </div>
              <div class="box5-item"
                   style="background-image: url('https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/bg3.png');">
                <div class="title fz-18 c-white">
                  代写咨询
                  <div class="icon">
                    <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/box5-3.svg" alt="">
                  </div>
                </div>
                <a class="cs-link c-white" href="https://tb.53kf.com/code/client/4fc71c35adbd778bae3a4e749e0b4c898/3"
                   target="_blank">在线咨询</a>
              </div>
              <div class="box5-item"
                   style="background-image: url('https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/bg2.png');">
                <div class="title fz-18 c-white">
                  代理合作
                  <div class="icon">
                    <img src="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/box5-2.svg" alt="">
                  </div>
                </div>
                <a class="cs-link c-white" href="https://tb.53kf.com/code/client/4fc71c35adbd778bae3a4e749e0b4c898/3"
                   target="_blank">在线咨询</a>
              </div>
            </div>


          </el-card>

        </div>
      </div>
    </div>


    <global-footer />
    <WechatLogin appid="wxf4e91ab7c148c9db" scope="snsapi_login" state="bind" :visible="wechatVisible"
                 v-on:wechatHidden="wechatVisible=false"
                 redirect_uri="https://i.ruanwen.la/wechat_req_res.html" />
  </div>
</template>

<script>
import * as Cookies from "js-cookie";

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

var code = getQueryString('code')

//引进来组件
import Head from '../global/Header.vue'
import Foot from '../global/Footer.vue'
import Left from '../own/Left.vue'
import WechatLogin from '../auth/WechatLogin'

import {ContentLoader} from 'vue-content-loader'

export default {
  data() {
    return {
      wechatVisible: false,
      orderProfile: {},
      dialogTableVisible: false
    }
  },
  computed: {
    profile() {
      return this.$store.state.profile
    },
    customerService() {
      return this.$store.state.customerService
    }
  },
  //方法
  methods: {
    getQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
    loadCS() {
      this.$http.get('personal/customer_service').then(response => {
        if (response.success) {
          this.$store.commit('changeCustomerService', response.data)
        }
      })
    },
    loadTStat() {
      this.$http.get('personal/transaction_stat').then(response => {
        if (response.success) {
          this.orderProfile = response.data
        }
      })
    }
  },

  //配置组件(对象的简写方式)
  components: {
    Head,
    Foot,
    Left,
    WechatLogin,
    ContentLoader
  },
  //   渲染时触发
  created() {
    this.loadTStat()

    this.loadCS()
  },
  mounted() {
    let code = this.getQueryString('code')
    if (code) {
      this.$http
          .get(
              'https://api.ruanwen.la/api/connect/wechat/response?action=bind&code=' +
              code
          )
          .then(response => {
            if (response.success) {
              this.$alert('绑定成功', {
                confirmButtonText: '确定',
                type: 'success'
              })
            }
          })
    }

    // const newLogin = Cookies.get('newLogin')
    // if (newLogin === 'true') {
    //   setTimeout(() => {
    //     this.$alert('近期有接到客户反馈，有骗子以媒体编辑和转载客户文章为由联系公司进行诈骗，在此提醒客户谨防上当！', '注意！！！', {
    //       confirmButtonText: '确定',
    //       type: 'warning',
    //       callback: action => {
    //         Cookies.set('newLogin', false)
    //       }
    //     });
    //   }, 3000)
    // }
  }
}

</script>


<style scoped lang="scss">


.el-dialog {
  width: 359px;
}

.add-woa-btn {
  /*margin-top: 10px;*/
  width: 135px;
  height: 135px;
}

.wechat-description {
  text-align: center;
  padding-top: 1px;
  margin-top: 24px;
  width: 600px;
  font-size: 14px;
  color: #666
}

.order_stat {
  font-size: 16px;
  /*padding-left: 12px;*/
  /*color: #fff;*/
  /*text-shadow: 0 0 2px #bdbdbd;*/
}

#login_container {
  /* position: fixed;
top: 40%;
left: 40%; */
  width: 300px;
  margin: 0 auto;
  background: #ffffff;
}

.profile_pad {
  width: 94%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
}

.profile_left,
.profile_right {
  /*width: 50%;*/
  width: 343px;
  display: flex;
}

.profile_left {
  flex-direction: column;
}

.profile_right {
  flex-direction: row;
  margin-top: 9px;
  margin-left: 3px;
}

.h3 {
  width: 70px;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #666;
}

.label {
  width: 80px;
  display: inline-block;
}

.personal {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 25px;
}

.avator,
.avator img {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  background-color: #ccc;
}

.rank {
  display: flex;
  flex-direction: column;
  margin-left: 5%;
}

.nickname {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333;
}

.telphone {
  height: 18px;
  line-height: 18px;
  margin: 6px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  color: #999;
}

.icon-shouji {
  font-size: 18px;
  margin-right: 5px;
}

.number {
  font-size: 12px;
  /* font-weight: bold; */
}

.plan {
  position: relative;
}

.plan progress {
  margin-top: 10px;
  width: 350px;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  border: 1px solid #f9f8f8;
  background-color: #fff;
  color: #fff;
  /*IE10*/
  border-radius: 6px;
}

progress::-moz-progress-bar {
  background: #fe8658;
}

progress::-webkit-progress-bar {
  background: #fff;
}

progress::-webkit-progress-value {
  background: #fe8658;
}

.details {
  font-size: 12px;
  color: #fff;
  position: absolute;
  left: 30px;
  top: 10px;
}

.company {
  display: flex;
  flex-direction: column;
}

.wechat-qrcode {
  box-shadow: 0 0 2px #9E9E9E;
  width: 120px;
  height: 120px;
}

.com_profile {
  font-size: 15px;
  color: #333;
}

.c_name {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #666;
}

.view {
  font-size: 12px;
  color: #78b8e9;
}

.edit {
  margin-top: 30px;
  font-size: 14px;
  color: #78b8e9;
}

/* 账户余额 */

.account {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
  align-items: center;
}

.rest {
  font-size: 14px;
  color: #666;
  margin-right: 12px
}

/* 个人中心 */

.per_center {
  background-color: #fff;
  height: 57px;
}

.per_center .per_center_left {
  font-size: 14px !important;
  color: #646464;
  line-height: 57px;
  margin-left: 35px;
}

.per_center_left span {
  font-size: 14px
}

.per_center .per_center_right ul {
  width: 345px;
  margin-right: 28px;
}

.per_center .per_center_right li {
  font: 15px "Microsoft Yahei";
  color: #434343;
  float: left;
  width: 25%;
  text-align: center;
  line-height: 57px;
}

.per_center_left a {
  color: #666666;
  font-size: 14px
}

.per_center .per_center_right li.now {
  font-size: 17px;
}

.main {
  width: 1200px;
  padding-top: 20px;
  display: flex;
  margin-bottom: 50px;
  justify-content: space-between
}

.main > .left {
}

.main > .right {
  flex: 1;

}


.card-header {
  display: flex;
  align-items: center;
  line-height: 1;
  color: #333;
  padding: 30px 30px 20px;

  > img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}


.main .main_top {
  height: 247px;
}

.main .main_top .per_profile {
  width: 662px;
  height: 100%;
  background-color: #fff;
  padding: 26px 30px 32px 30px;
  box-sizing: border-box;
}

.main .main_top .per_profile .per_profile_top span,
.main .main_top .per_profile .per_profile_top > a {
  font: 14px "Microsoft YaHei";
  color: #bababa;
}

.main .main_top .per_profile .per_profile_center {
  margin: 10px 0;
}

.main .main_top .per_profile .per_profile_center > img {
  width: 100px;
  height: 80px;
  border-radius: 50%;
}

.main .main_top .per_profile .per_profile_center > div {
  margin-left: 25px;
}

.main .main_top .per_profile .per_profile_center > div h3 {
  font: 18px "Microsoft YaHei";
  color: #161616;
  margin-bottom: 10px;
}

.main .main_top .per_profile .per_profile_center > div > img {
  margin-right: 16px;
}

.main .main_top .per_profile .per_profile_center > div a {
  font: 14px "Microsoft YaHei";
  color: #86bfef;
}

.main .main_top .per_profile .per_profile_bottom span {
  font: 14px "Microsoft YaHei";
  color: #979797;
  margin-right: 30px;
}

.main .main_top .per_profile .per_profile_bottom span:nth-child(2) {
  margin-right: 30px;
}

.main .main_top .per_profile .per_profile_bottom span:last-of-type {
  color: #555;
  margin: 0;
}

.main .main_top .per_profile .per_profile_bottom .bar {
  margin-top: 16px;
  width: 440px;
  height: 31px;
  background-color: #fc835a;
  border-radius: 5px;
}

.main .main_top .per_profile .per_profile_bottom button {
  margin-top: 16px;
  height: 31px;
  width: 60px;
  border-radius: 15px;
  border: 0;
  color: #fff;
  font: 14px "Microsoft YaHei";
  background-color: #fc835a;
}

.main .main_top .com_profile {
  width: 426px;
  height: 100%;
  background-color: #fff;
  padding: 26px 30px 32px 30px;
  box-sizing: border-box;
}

.main .main_top .com_profile .com_profile_top {
  margin-bottom: 20px;
}

.main .main_top .com_profile .com_profile_top span,
.main .main_top .com_profile .com_profile_top > a {
  font: 14px "Microsoft YaHei";
  color: #bababa;
}

.main .main_top .com_profile p {
  font: 16px "Microsoft YaHei";
  color: #979797;
  margin-bottom: 30px;
}

.main .main_top .com_profile p:first-of-type > span {
  font: 18px "Microsoft YaHei";
  color: #555;
}

.main .main_top .com_profile p > span {
  font: 16px "Microsoft YaHei";
  color: #7c7c7c;
}

.main .main_center .order-card {
  display: flex;
  justify-content: space-between;
}

.main .main_center .order-item {
  width: 100%;
  height: 92px;
  position: relative;
  background: url("../../img/orange.png") no-repeat center center;
  background-size: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main .main_center .order-item:last-of-type {
  margin-right: 0px;
}

.main .main_center .order-item p {
  font-size: 16px;
  color: #fff;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main .main_center .label {
  font-size: 16px
}

.main .main_center ul li p > span:nth-child(3) {
  /* display: inline-block;
margin-bottom: 10px; */
  font-size: 24px;
  margin-left: 10px;
}

.main .main_center ul li a {
  position: absolute;
  bottom: 14px;
  right: 28px;
  font-size: 14px;
  color: #fff;
}

.main .main_bottom {
  min-height: 600px;
  position: relative;
}

.main .main_bottom .begin {
  margin-top: 33px;
  margin-left: 30px;
  font-size: 14px;
  color: #333;
}

.main .main_bottom .begin select {
  margin-left: 16px;
  width: 100px;
  height: 30px;
}

.main .main_bottom .end {
  margin-top: 33px;
  margin-left: 30px;
  font-size: 14px;
  color: #333;
}

.main .main_bottom .end select {
  margin-left: 16px;
  width: 100px;
  height: 30px;
}

.order-item {
  /*min-width: 400px;*/
}

.main .main_center div:first-child > .order-item {
  background: url("../../img/personal_article_list.png") no-repeat center center;
  -webkit-background-size: contain;
  background-size: contain;
  /*  background-size: 100% 100%;*/
}

.main .main_center div:nth-child(2) > .order-item {
  background: url("../../img/personal_nopay.png") no-repeat center center;
  -webkit-background-size: contain;
  background-size: contain;
}

.main .main_center div:nth-child(3) > .order-item {
  background: url("../../img/personal_active.png") no-repeat center center;
  -webkit-background-size: contain;
  background-size: contain;
}

.main .main_center div:nth-child(4) > .order-item {
  background: url("../../img/personal_finish.png") no-repeat center center;
  -webkit-background-size: contain;
  background-size: contain;
}

.profile_box .profile_companyprofile_title {
  border-bottom: 1px solid #eaeaea;
}

.orangeline {
  width: 6px;
  height: 18px;
  background: #f08c19;
  margin-bottom: 6px;
  display: inline-block;
  vertical-align: middle;
}


.addwoabtn {
  width: 218px;
  height: 60px;
  line-height: 60px;
  color: #f08c19;
  border: 1px solid #f08c19;
  text-align: center;
  margin-top: 65px;
  margin-right: auto;
  margin-left: auto;
  border-radius: 5px;
}

.addwoabtn > img {
  width: 20px;
  height: 20px;
  margin-top: -2px;
  vertical-align: middle;
}

.home_title {
  border-bottom: 1px solid #eaeaea;
}

.showlist {
  /*width: 865px;*/
  /*margin: 65px auto 0;*/
  display: flex;
  justify-content: space-between;
}

.showlist > li {
  width: 222px;
  height: 138px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(28, 86, 130, 0.1);
  border-radius: 10px;
}

.showlist > li img {
  width: 47px;
  height: 42px;
  padding-top: 36px;
  padding-left: 88px;
  /*border-radius: 50%;*/
  /*box-shadow: 0 0 20px #F5F5F5;*/
}

.showlist li:hover > p {
  color: #0082e6 !important;
  cursor: pointer;
}

.showlist li:hover {
  cursor: pointer;
}

.showlist_weixin {
  width: 400px;
  margin: 17px auto 0;
  display: flex;
  justify-content: space-between;
}

.showlist_weixin > li img {
  width: 150px;
  box-shadow: 0 0 20px #F5F5F5;
}

/*.showlist_weixin li:hover > p {
  color: #0082e6 !important;
  cursor: pointer;
}

.showlist_weixin li:hover {
  cursor: pointer;
}*/

</style>

<style scoped lang="scss">
.box {
  height: 100%;
}

.el-dialog {
  width: 359px;
}

/*个人信息修改  328*/

.add-woa-btn {
  width: 250px;
  height: 50px;
}

.wechat-description {
  text-align: center;
  margin-top: 24px;
  font-size: 14px;
  color: #666
}

.order_stat {
  font-size: 26px;
  padding-left: 12px;
  color: #fff;
  text-shadow: 0 0 2px #bdbdbd;
}

#login_container {
  /* position: fixed;
top: 40%;
left: 40%; */
  width: 300px;
  margin: 0 auto;
  background: #ffffff;
}

.profile_pad {
  margin: 0 auto;
  display: flex;
  flex-direction: row;
}

.profile_left,
.profile_right {
  display: flex;
}

.profile_left {
  flex-direction: column;
}

.profile_right {
  flex-direction: row;
}

.h3 {
  width: 70px;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #666;
}

.label {
  width: 80px;
  display: inline-block;
}

.personal {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.avator,
.avator img {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  background-color: #ccc;
}

.rank {
  display: flex;
  flex-direction: column;
}

.nickname {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333;
}

.telphone {
  height: 18px;
  line-height: 18px;
  margin: 6px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  color: #999;
}

.icon-shouji {
  font-size: 18px;
  margin-right: 5px;
}

.number {
  font-size: 12px;
  /* font-weight: bold; */
}

.plan {
  position: relative;
}

.plan progress {
  margin-top: 10px;
  width: 350px;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  border: 1px solid #f9f8f8;
  background-color: #fff;
  color: #fff;
  /*IE10*/
  border-radius: 6px;
}

progress::-moz-progress-bar {
  background: #fe8658;
}

progress::-webkit-progress-bar {
  background: #fff;
}

progress::-webkit-progress-value {
  background: #fe8658;
}

.details {
  font-size: 12px;
  color: #fff;
  position: absolute;
  left: 30px;
  top: 10px;
}

/* 个人信息右侧 */

.company {
  display: flex;
  flex-direction: column;
  margin-right: 48px
}

.wechat-qrcode {
  box-shadow: 0 0 2px #9E9E9E;
  width: 120px;
  height: 120px;
}

.com_profile {
  font-size: 15px;
  color: #333;
}

.c_name {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #666;
}

.view {
  font-size: 12px;
  color: #78b8e9;
}

.edit {
  margin-top: 30px;
  font-size: 14px;
  color: #78b8e9;
}

/* 账户余额 */

.account {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
  align-items: center;
}

.rest {
  font-size: 14px;
  color: #666;
  margin-right: 12px
}


/* 个人中心 */

.per_center {
  background-color: #fff;
  height: 57px;
}

.per_center .per_center_left {
  font-size: 14px !important;
  color: #646464;
  line-height: 57px;
  margin-left: 35px;
}

.per_center_left span {
  font-size: 14px
}

.per_center .per_center_right ul {
  width: 345px;
  margin-right: 28px;
}

.per_center .per_center_right li {
  font: 15px "Microsoft Yahei";
  color: #434343;
  float: left;
  width: 25%;
  text-align: center;
  line-height: 57px;
}

.per_center_left a {
  color: #666666;
  font-size: 14px
}

.per_center .per_center_right li.now {
  font-size: 17px;
}


.main .main_top {
  height: 247px;
}

.main .main_top .per_profile {
  width: 662px;
  height: 100%;
  background-color: #fff;
  padding: 26px 30px 32px 30px;
  box-sizing: border-box;
}

.main .main_top .per_profile .per_profile_top span,
.main .main_top .per_profile .per_profile_top > a {
  font: 14px "Microsoft YaHei";
  color: #bababa;
}

.main .main_top .per_profile .per_profile_center {
  margin: 10px 0;
}

.main .main_top .per_profile .per_profile_center > img {
  width: 100px;
  height: 80px;
  border-radius: 50%;
}

.main .main_top .per_profile .per_profile_center > div {
  margin-left: 25px;
}

.main .main_top .per_profile .per_profile_center > div h3 {
  font: 18px "Microsoft YaHei";
  color: #161616;
  margin-bottom: 10px;
}

.main .main_top .per_profile .per_profile_center > div > img {
  margin-right: 16px;
}

.main .main_top .per_profile .per_profile_center > div a {
  font: 14px "Microsoft YaHei";
  color: #86bfef;
}

.main .main_top .per_profile .per_profile_bottom span {
  font: 14px "Microsoft YaHei";
  color: #979797;
  margin-right: 30px;
}

.main .main_top .per_profile .per_profile_bottom span:nth-child(2) {
  margin-right: 30px;
}

.main .main_top .per_profile .per_profile_bottom span:last-of-type {
  color: #555;
  margin: 0;
}

.main .main_top .per_profile .per_profile_bottom .bar {
  margin-top: 16px;
  width: 440px;
  height: 31px;
  background-color: #fc835a;
  border-radius: 5px;
}

.main .main_top .per_profile .per_profile_bottom button {
  margin-top: 16px;
  height: 31px;
  width: 60px;
  border-radius: 15px;
  border: 0;
  color: #fff;
  font: 14px "Microsoft YaHei";
  background-color: #fc835a;
}

.main .main_top .com_profile {
  width: 426px;
  height: 100%;
  background-color: #fff;
  padding: 26px 30px 32px 30px;
  box-sizing: border-box;
}

.main .main_top .com_profile .com_profile_top {
  margin-bottom: 20px;
}

.main .main_top .com_profile .com_profile_top span,
.main .main_top .com_profile .com_profile_top > a {
  font: 14px "Microsoft YaHei";
  color: #bababa;
}

.main .main_top .com_profile p {
  font: 16px "Microsoft YaHei";
  color: #979797;
  margin-bottom: 30px;
}

.main .main_top .com_profile p:first-of-type > span {
  font: 18px "Microsoft YaHei";
  color: #555;
}

.main .main_top .com_profile p > span {
  font: 16px "Microsoft YaHei";
  color: #7c7c7c;
}

.main .main_center .order-card {
  display: flex;
  justify-content: space-between;
}

.main .main_center .order-card .order-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.main .main_center div div {
  width: 254px;
  height: 92px;
  position: relative;
  background: url("../../img/orange.png") no-repeat center center;
  background-size: 100%;
  text-align: center;
  /* line-height: 92px; */
  display: table;
  box-sizing: border-box;
}

.main .main_center div div:last-of-type {
  margin-right: 0px;
}

.main .main_center div div p {
  font-size: 16px;
  color: #fff;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main .main_center .label {
  font-size: 16px
}

.main .main_center ul li p > span:nth-child(3) {
  /* display: inline-block;
margin-bottom: 10px; */
  font-size: 24px;
  margin-left: 10px;
}

.main .main_center ul li a {
  position: absolute;
  bottom: 14px;
  right: 28px;
  font-size: 14px;
  color: #fff;
}

.main .main_bottom {
  min-height: 600px;
  position: relative;
}

.main .main_bottom .begin {
  margin-top: 33px;
  margin-left: 30px;
  font-size: 14px;
  color: #333;
}

.main .main_bottom .begin select {
  margin-left: 16px;
  width: 100px;
  height: 30px;
}

.main .main_bottom .end {
  margin-top: 33px;
  margin-left: 30px;
  font-size: 14px;
  color: #333;
}

.main .main_bottom .end select {
  margin-left: 16px;
  width: 100px;
  height: 30px;
}

.main .main_center div div:first-child {
  background: url("../../img/orange.png") no-repeat center center;
  background-size: 100% 100%;
}

.main .main_center div div:nth-child(2) {
  background: url("../../img/blue.png") no-repeat center center;
  background-size: 100% 100%;
}

.main .main_center div div:nth-child(3) {
  background: url("../../img/green.png") no-repeat center center;
  background-size: 100% 100%;
}

.main .main_center div div:nth-child(4) {
  background: url("../../img/gray.png") no-repeat center center;
  background-size: 100% 100%;
}

.profile_box .profile_companyprofile_title {
  border-bottom: 1px solid #eaeaea;
}

.orangeline {
  width: 6px;
  height: 18px;
  background: #f08c19;
  margin-bottom: 6px;
  display: inline-block;
  vertical-align: middle;
}

.addwoabtn {
  width: 218px;
  height: 60px;
  line-height: 60px;
  color: #f08c19;
  border: 1px solid #f08c19;
  text-align: center;
  margin-top: 65px;
  margin-right: auto;
  margin-left: auto;
  border-radius: 5px;
}

.addwoabtn > img {
  width: 20px;
  height: 20px;
  margin-top: -2px;
  vertical-align: middle;
}

.home_title {
  border-bottom: 1px solid #eaeaea;
}

.showlist {
  width: 865px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.showlist > li img {
  width: 87px;
  height: 87px;
  border-radius: 50%;
  box-shadow: 0 0 20px #F5F5F5;
}

.showlist li:hover > p {
  color: #0067ed !important;
  cursor: pointer;
}

.showlist li:hover {
  cursor: pointer;
}

.right_top {
  display: flex;
  justify-content: space-between;
}

.class_tb {
  background-image: url(../../assets/class_tb.png);
  background-size: 100%;
}

.totalicon {
  width: 17px;
  height: 20px;
  display: inline-block;
  background-position: 0 2px;

}

.clearfix {
  /*  display: flex;
    align-items: center;*/

  font-size: 16px;
  font-weight: 500;
}

.clearfix span {
  margin-left: 10px;
}

.right_top_left {
  width: 880px;
  display: flex;
  flex-direction: column;
}

.card-1 {
  width: 1200px;
  height: 330px;
  display: flex;
  justify-content: space-between;
}

.card-2 {
  margin-top: 15px;
  height: 440px;
}

.card1_main {
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .card1-left {
    display: flex;
    align-items: center;

    > .avatar {
      width: 76px;
      margin-right: 20px;
    }

    .user-info-box {
      font-size: 14px;
      color: #666;
      line-height: 1;

      .user-name {
        font-size: 20px;
        color: #333;
        display: flex;
        align-items: center;
        white-space: nowrap;

        .level {
          width: 156px;
          height: 26px;
          background: url("https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/home/level-bg.svg") no-repeat center;
          margin-left: 12px;
          padding-left: 12px;
          display: flex;
          justify-content: space-evenly;
          align-items: center;
        }
      }

      .balance-box {
        height: 46px;
        border-radius: 6px;
        display: flex;
        align-items: center;
      }

      .price-red {
        color: red;
        font-size: 16px;
      }

      .btn-recharge {
        margin-left: 15px;
        width: 92px;
        height: 36px;
        background: #FF9C00;
        border-radius: 18px;
        color: #fff;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
      }
    }
  }

  .card1-right {
    display: flex;
    align-items: center;
  }
}

.row-container {
  display: flex;
  justify-content: space-between;

  .card-box3 {
    width: 270px;
    display: flex;
    flex-direction: column;
  }
}

.toal1_list {
  margin-top: 16px;

  &.has-btn {
    margin-top: 6px;
  }
}

.toal1_list span:nth-child(1) {
  display: inline-block;
}

.val_total1 {
  /*margin-left: 30px;*/

  &.profile-name{
    width: 90px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.bluefont {
  color: #0066FF;
  margin-left: 30px;
}

.bluefont2 {
  color: #5185FF;
}

.text-red {
  color: red;
}

.box_card4 {
  width: 100%;
  height: 570px;
}

.funcicon {
  background-position: 0 -20px;
  width: 18px;
  height: 18px;
}

.card2_main_con {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

.carousel-box {
  width: 320px;
  height: 190px;

  /deep/ {
    .el-carousel__indicators--horizontal {
      left: 70px;
      bottom: 23px;

      .el-carousel__indicator--horizontal {
        width: 36px;
        margin: 0 5px;

        .el-carousel__button {
          width: 36px;
          height: 3px;
          opacity: 1;
          border-radius: 2px;
        }

        &.is-active {
          .el-carousel__button {
            width: 36px;
            background-color: #0070EF;
          }
        }
      }
    }
  }
}

.card2_main {
  width: 587px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 auto;
}

.card2_main_item {
  font-size: 16px;
  width: 110px;
  height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  &:hover {
    box-shadow: 0px 6px 20px 0px rgba(127, 136, 156, 0.1000);
    border-radius: 10px;
  }

  > img {
    width: 56px;
    height: 56px;
  }
}

.card2_main_item_name {
  font-weight: bold;
  color: #666;
}

.khjl {
  width: 21px;
  height: 21px;
  background-position: 0 -60px;
}

.wxts {
  width: 20px;
  height: 18px;
  background-position: 0 -80px;
}

.mtxy {
  width: 24px;
  height: 19px;
  background-position: 0 -50px;
  display: inline-block;
}

.gh_con {
  display: flex;
  position: absolute;
  right: 72px;
}

.card3_main {
  margin-top: 50px;
  margin-left: 30px;
}

.erweima {
  width: 80px;
  height: 80px;
  border: 1px solid #E6E9F0;
  border-radius: 10px;
  margin-right: 16px;
}

.personal_new {
  /*padding: 0px 0 0 11px;*/
}

.personal_list {
  margin-top: 16px;
  font-size: 14px;
  color: #666666;

  &.personal-list-title {
    font-size: 20px;
    color: #333;


    .gw {
      width: 100px;
      padding: 7px 15px;
      background-color: rgba(199, 149, 91, .1);
      color: #C7955B;
      border-radius: 10px;
    }


  }
}

.personal_list span {
  display: inline-block;
  width: 150px;
}

.personal_list span:nth-child(2n) {
  display: inline-block;
  width: 200px;
}

.card4_main {
  padding: 10px 20px;
}

.card4_main_top {
  width: 940px;
  height: 56px;
  line-height: 56px;
  background: #E9F3FF;
  border-radius: 28px;
  padding-left: 30px;
  display: flex;
  align-items: center;
}

.time_new {

}

.card4img {
  width: 139px;
  height: 100px;
  margin-left: 114px;
}

.card4_main_bot {
  margin-left: 25px;
  width: 880px;
  font-size: 14px;
  color: #666;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;

  .step-item {
    width: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.box5 {
  width: 940px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .box5-item {
    width: 290px;
    height: 120px;
    background: no-repeat center;
    background-size: contain;

    > .title {
      height: 80px;
      padding-left: 40px;
      padding-right: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > .icon {
        width: 53px;
        height: 53px;
        border-radius: 26.5px;
        background-color: rgba(255, 255, 255, .1);

        > .svg-icon {
          width: 50px;
          height: 50px;
        }
      }
    }

    .cs-link {
      background-color: rgba(255, 255, 255, .12);
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}


.mt_list {
  padding: 0 0 0 57px;
  display: flex;
  flex-direction: column;
}

.support-intro {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  font-size: 14px;
  color: #666;

  .support-intro-item {
    margin-top: 30px;
    display: flex;
    align-items: center;
    line-height: 1;

    > img {
      margin-right: 8px;
    }
  }
}

.gh_icon {
  width: 19px;
  /*height: 17px;*/
  background-image: url(../../assets/refurbish.png);
  margin-right: 10px;

}

.clearfix2 {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;
}

.card5_main {
  width: 1530px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.card5_main_item {
  width: 280px;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  margin-top: 30px;

}

.line {
  width: 210px;
  height: 1px;
  background: #EDF1F5;
  margin-top: 19px;
}

.tj_text {

  font-size: 14px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #909399;
}

.red_font {

  font-size: 18px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #FC4219;
}

.new_price {
  margin-top: 30px;
}

.new_wz_name {
  margin-top: 21px;
}

.wz_logo_con {
  width: 123px;
  height: 48px;
  margin-top: 32px;
}

.wz_logo {

  width: auto;

  height: auto;

  max-width: 100%;

  max-height: 100%;
}

.funcicon {
  background-position: 0 -20px;
  width: 18px;
  height: 18px;
}

.khjl {
  width: 21px;
  height: 21px;
  background-position: 0 -60px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Index.vue